/**
 * @description Events can be sent over Mitt event buses and - because the event instances (which are Objects) aren't
 * dereferenced - used to transmit data across listeners & emitters.
 */
export default class BaseEvent {
    requestPreventDefaultBehaviour: boolean = false;
}
